import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { AxiosError } from 'axios';
import { Journal, UpdateJournalReq } from '../types/journal';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { PatchResponseBody } from '../types/api-response';
import queryClient from '../query-client';

type UpdateJournalsRequest = UpdateJournalReq[];

async function updateJournals(workpaperId: string, req: UpdateJournalsRequest): Promise<PatchResponseBody<Journal>> {
    const { data } = await api.patch(`/workpapers/${workpaperId}/journals`, req);
    return data;
}

export function useUpdateJournals(
    worksheetId?: string,
    journalId?: string
): UseMutationResult<PatchResponseBody<Journal>, AxiosError, UpdateJournalsRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation((req) => updateJournals(workpaperId, req), {
        onSettled: () => {
            if (worksheetId) {
                queryClient.invalidateQueries(['worksheets', worksheetId]);
            }
            queryClient.invalidateQueries(['journals', workpaperId]);
            queryClient.invalidateQueries(['journals', journalId]);
            queryClient.invalidateQueries(['workpaper-progress', workpaperId]);
        },
    });
}
